// GC Material field schema for forms and detail pages
// Used by CreateGCMaterialPage and GCMaterialDetailPage

const GCMATERIAL_FIELD_SCHEMA = [
  { name: 'SEN', label: 'SEN', type: 'text', required: true, defaultValue: '' },
  { name: 'articleType', label: 'Article Type', type: 'text', required: true, defaultValue: '' },
  { name: 'unitCost', label: 'Unit Cost', type: 'number', required: true, defaultValue: 0 },
  {
    name: 'currency',
    label: 'Currency',
    type: 'select',
    required: true,
    defaultValue: '',
    options: [
      { label: 'USD', value: 'USD' },
      { label: 'EUR', value: 'EUR' },
      { label: 'CNY', value: 'CNY' },
      { label: 'MOP', value: 'MOP' },
      { label: 'HKD', value: 'HKD' },
    ],
  },
  { name: 'unit', label: 'Unit', type: 'text', required: true, defaultValue: '' },
  { name: 'MOQ', label: 'MOQ', type: 'number', required: true, defaultValue: 1 },
  { name: 'ECCN', label: 'ECCN', type: 'text', required: false, defaultValue: '' },
  { name: 'ctyOfOrigin', label: 'Country of Origin', type: 'text', required: false, defaultValue: '' },
  { name: 'description', label: 'Description', type: 'text', required: false, defaultValue: '' },
  { name: 'SAPMaterialNumber', label: 'SAP Material Number', type: 'text', required: false, defaultValue: '' },
  { name: 'purchaseScenario', label: 'Purchase Scenario', type: 'text', required: false, defaultValue: '' },
  { name: 'CSID', label: 'CSID', type: 'checkbox', required: false, defaultValue: false },
  { name: 'zuroa', label: 'ZUROA', type: 'checkbox', required: false, defaultValue: false },
  { name: 'priceTerm', label: 'Price Term', type: 'text', required: false, defaultValue: '' },
  { name: 'chargeType', label: 'Charge Type', type: 'text', required: false, defaultValue: '' },
  { name: 'vendor', label: 'Vendor', type: 'text', required: false, defaultValue: '' },
  {
    name: 'requiredLicenseManager',
    label: 'Required License Manager',
    type: 'checkbox',
    required: false,
    defaultValue: false,
  },
  { name: 'isBuildingX', label: 'Is Building X', type: 'checkbox', required: false, defaultValue: false },
  { name: 'isStandAlonePR', label: 'Stand Alone PR', type: 'checkbox', required: false, defaultValue: false },
  { name: 'discontinued', label: 'Discontinued', type: 'checkbox', required: false, defaultValue: false },
]

export default GCMATERIAL_FIELD_SCHEMA
